// eslint-disable-next-line no-restricted-imports
import type { PaperProps } from '@mui/material';
// eslint-disable-next-line no-restricted-imports
import { Paper as MuiPaper } from '@mui/material';

export type { PaperProps };

export const Paper = ({ elevation = 0, square = true, ...props }: PaperProps) => (
  <MuiPaper
    elevation={elevation}
    square={square}
    {...props}
  />
);
